import request from '@/lib/request';

const api = {};

// 获取员工列表
api.getEmployeeList = (reqData, autoErrorTips = true) => request({
  url: 'v3/cp/user/authority/management',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 获取员工角色列表
api.getRoleList = (reqData, autoErrorTips = true) => request({
  url: 'v3/cp/user/role/list',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 变更绑定橱窗
api.modifyBindMedia = (reqData, autoErrorTips = true) => request({
  url: 'v3/cp/media/bind/modify',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 解除绑定橱窗
api.unBindMedia = (reqData, autoErrorTips = true) => request({
  url: 'v3/cp/media/unbind',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 接受/拒绝新员工
api.acceptNewEmployee = (reqData, autoErrorTips = true) => request({
  url: 'v3/cp/user/confirm',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 删除员工
api.removeEmployee = (reqData, autoErrorTips = true) => request({
  url: 'v3/cp/user/remove',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

export default api;
